module.exports = __webpack_public_path__ + "static/img/m-news.003c677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/m-news.jpg
// module id = U5fP
// module chunks = 1